// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

import Viewer from 'v-viewer';
import App from './App';
import router from './router';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import VMprototype from './utils/vm.prototype'
import * as echarts from 'echarts';
import store from './vuex/store';
import moment from 'moment'
import Loading from '@/components/loading'

// ----------图片预览组件-----------
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
let options = {//更多配置项 https://photoswipe.com/documentation/options.html
  fullscreenEl: false, //控制是否显示右上角全屏按钮
  closeEl: true, //控制是否显示右上角关闭按钮
  tapToClose: true, //点击滑动区域应关闭图库
  shareEl: false, //控制是否显示分享按钮
  zoomEl: false, //控制是否显示放大缩小按钮
  counterEl: false, //控制是否显示左上角图片数量按钮
  tapToToggleControls: true, //点击应切换控件的可见性
  clickToCloseNonZoomable: true, //点击图片应关闭图库，仅当图像小于视口的大小时
  indexIndicatorSep: ' / '//图片数量的分隔符
}
Vue.use(preview, options)
Vue.use(preview)
// ---------------------------------
Vue.component('Loading', Loading)

Vue.use(ViewUI);
Vue.use(VMprototype)

Vue.use(Viewer);

Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.prototype.$moment = moment;

router.beforeEach((to, from, next) => {
  ViewUI.LoadingBar.start();
  next();
});

router.afterEach(route => {
  ViewUI.LoadingBar.finish();
});

/* eslint-disable no-new */
let vue = new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});
export default vue



// WEBPACK FOOTER //
// ./src/main.js